import React from 'react';
import { classIf } from '../../data/utils';

function LiveMatchBetGroup(props) {

    function handleClick() {
        props.changeAggregata(props.idAggregata);
    }

    return (
        <div data-id={`a-${props.idAggregata}`} className={"bg-bianco nero bordo-tondo elemento-macro-sub pointer filter subgoals" + classIf(props.active, 'icona-selezionata')} onClick={handleClick} >{props.desc}</div>
    );
}

export default LiveMatchBetGroup;